module.exports = __webpack_public_path__ + "static/media/calendar-minus.bc9e111f.svg";